<template>
  <div class="container Admin text-left">
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
    <b-card v-if="$store.state.auth.user.role !== 'limited_editor' && $store.state.changeRequests.dmoPartnerRequests.length" class="mt-5">
      <div>
        <h1>DMO Partner Requests</h1>
        <div class="table-responsive">
          <table class="table table-sm table-dmo text-left">
            <thead>
              <tr>
                <th>Name</th>
                <th>Organizations</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Reject</th>
                <th>Approve</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="request in $store.state.changeRequests.dmoPartnerRequests">
                <tr class="dmo-table-row-top">
                  <td>
                    <router-link :to="{ name: 'users detail', params: { userId: request.user._id } }">{{
                      request.user.first_name }} {{ request.user.last_name }}</router-link>
                  </td>
                  <td style="white-space: nowrap">
                    {{ formatOrganizationsField(request.user.organizations) }}
                  </td>
                  <td>{{ request.user.email }}</td>
                  <td>{{ request.user.telephone | telephoneNumber }}</td>
                  <td><b-button size="sm btn-white" @click="openDmoModal(request._id)">Reject</b-button></td>
                  <td><b-button size="sm" :disabled="isLoading"
                      @click="dmoSendAcceptRejectRequest(true, request._id)">Approve</b-button></td>
                </tr>
                <tr class="dmo-table-row-bottom">
                  <td colspan="1">
                    <b>Reason</b>
                  </td>
                  <td colspan="100">
                    {{ request.justification }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
    <b-card v-if="this.$store.state.auth.mUser.role === 'admin' && $store.state.changeRequests.pendingCities.length"
      class="mt-5">
      <div>
        <h1>City Edit Suggestion</h1>
        <div class="table-responsive">
          <table class="table table-sm table-striped text-left">
            <thead>
              <tr>
                <th>City</th>
                <th>From</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Reject</th>
                <th>Approve</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in $store.state.changeRequests.pendingCities" :key="request._id">
                <td>
                  <router-link :to="{ name: 'city detail', params: { cityId: request.requestable_id } }">{{
                    request.listing.name }}</router-link>
                </td>
                <td>{{ request.requestedByUser.first_name }} {{ request.requestedByUser.last_name }}</td>
                <td>{{ request.requestedByUser.email }}</td>
                <td>{{ request.requestedByUser.telephone | telephoneNumber }}</td>
                <td><b-button size="sm btn-white" @click="rejectCityChangeRequest(request._id)">Reject</b-button></td>
                <td><b-button size="sm" :disabled="isLoading"
                    @click="approveCityChangeRequest(request._id)">Approve</b-button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
    <b-card class="mt-5" v-if="$store.state.auth.user.role !== 'limited_editor'">
      <h1>Events Pending Approval</h1>
      <div class="eventsPendingApproval">
        <div class="table-responsive">
          <table class="table table-sm table-striped text-left">
            <thead>
              <tr>
                <th>Organization</th>
                <th>Event Name</th>
                <th>Start On</th>
                <th>End On</th>
                <th>Submitted</th>
                <th>Reject</th>
                <th>Approve</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in $store.state.changeRequests.pendingEvents" :key="request._id">
                <td v-if="request.organization_id">
                  <router-link :to="{ name: 'org detail', params: { orgId: request.organization_id } }">{{
                    request.organization.name }}</router-link>
                </td>
                <td v-if="request.requestable_id">
                  <router-link :to="{ name: 'event detail', params: { eventId: request.requestable_id } }">{{
                    request.listing.name }}</router-link>
                </td>
                <td v-else>
                  <router-link :to="{ name: 'event detail', params: { eventId: request._id } }">{{ request.listing.name
                  }}</router-link>
                </td>
                <td>{{ request.listing.start_on | dateOnly }}</td>
                <td>{{ request.listing.end_on | dateOnly }}</td>
                <td>{{ request.created_at | dateTime }}</td>
                <td><b-button size="sm btn-white" :disabled="isLoading" v-on:click="rejectChangeRequest(request._id, 'event')">Reject</b-button>
                </td>
                <td><b-button size="sm" :disabled="isLoading"
                    v-on:click="approveEventChange(request._id, request.requestable_id)">Approve</b-button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
    <b-card class="mt-5" v-if="$store.state.auth.user.role !== 'limited_editor'">
      <div class="locationsPendingApproval">
        <h1>Locations Pending Approval</h1>
        <div class="table-responsive">
          <table class="table table-sm table-striped text-left">
            <thead>
              <tr>
                <th>Organization</th>
                <th>Location Name</th>
                <th>City</th>
                <th>Type</th>
                <th>Reject</th>
                <th>Approve</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in $store.state.changeRequests.pendingLocations" :key="request._id">
                <td v-if="request.organization_id">
                  <router-link :to="{ name: 'org detail', params: { orgId: request.organization_id } }">{{
                    request.organization.name }}</router-link>
                </td>
                <td v-if="request.requestable_id">
                  <router-link :to="{ name: 'locations detail', params: { locationId: request.requestable_id } }">{{
                    request.listing.name }}</router-link>
                </td>
                <td v-else>
                  <router-link :to="{ name: 'locations detail', params: { locationId: request._id } }">{{
                    request.listing.name }}</router-link>
                </td>
                <td>{{ request.listing.city }}</td>
                <td>{{ request.requestable_type }}</td>
                <td><b-button size="sm btn-white" :disabled="isLoading"
                    v-on:click="rejectChangeRequest(request._id, 'location')">Reject</b-button></td>
                <td><b-button size="sm" :disabled="isLoading"
                    v-on:click="approveLocationChange(request._id, request.requestable_id)">Approve</b-button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
    <b-card class="mt-5" v-if="$store.state.auth.user.role !== 'limited_editor'">
      <div class="membershipPendingApproval">
        <h1>Organization Membership Requests</h1>
        <div class="table-responsive">
          <table class="table table-sm table-striped text-left">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Request To Join</th>
                <th>Reject</th>
                <th>Approve</th>
              </tr>
            </thead>
            <tbody v-if="$store.state.changeRequests.membershipRequestList">
              <tr v-for="request in $store.state.changeRequests.membershipRequestList" :key="request._id">
                <template v-if="request.organizations[0]">
                  <td>{{ request.users[0].first_name }} {{ request.users[0].last_name }}</td>
                  <td>{{ request.users[0].email }}</td>
                  <td>{{ request.users[0].telephone | telephoneNumber }}
                  </td>
                  <td v-if="request.organizations[0]">
                    <router-link :to="{ name: 'org detail', params: { orgId: request.organization_id } }">{{
                      request.organizations[0].name }}</router-link>
                  </td>
                  <td><b-button size="sm btn-white" :disabled="isLoading"
                      @click="membershipSendAcceptRejectRequest(false, request._id)">Reject</b-button></td>
                  <td><b-button size="sm" :disabled="isLoading" @click="membershipSendAcceptRejectRequest(true, request._id)">Approve</b-button>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
    <b-card class="mt-5" v-if="$store.state.auth.user.role !== 'limited_editor'">
      <div class="unverifiedUsers">
        <h1>Unverified Users</h1>
        <!-- <b-table striped hover :items="orgItems"></b-table> -->
        <div class="table-responsive">
          <table class="table table-sm table-striped text-left">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Confirmation Sent</th>
                <th>Remove</th>
                <th>Verify</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in $store.state.changeRequests.unverifiedUserList" :key="user._id">
                <td>{{ user.first_name }} {{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td>
                  {{ user.confirmation_sent_at | dateAtTime }}
                </td>
                <td><b-button class="sm btn-white" size="sm" :disabled="isLoading"
                    @click="adminDeleteUnverifiedUser(user.username, user.email)">Remove</b-button></td>
                <td><b-button size="sm" :disabled="isLoading" @click="verifyUser(user.username)">Verify</b-button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
    <div class="modal" v-if="showRejectDmoModal">
      <div class="modal-content">
        <p>Briefly describe why the DMO Partner request was rejected.</p>
        <textarea v-model="dmoRejectionResponse"></textarea>
        <p class="modal-error">Please enter a message that will be emailed to the Partner.</p>
        <div class="modal-actions">
          <b-button name="modal-confirm" :disabled="isLoading" class="btn btn-dmo"
            @click="dmoSendAcceptRejectRequest(false, rejectedDmoRequestId)">{{
              handleDmoButtonText
            }}</b-button>
          <b-button name="modal-cancel" class="btn btn-white" @click="closeDmoModal()">Cancel</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import dateFNS from 'date-fns';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Component, Vue } from 'vue-property-decorator';
import BreadcrumbsHelper from './common/BreadcrumbsHelper.vue';

@Component({
  data() {
    return {
      isLoading: false,
      showRejectDmoModal: false,
      dmoRejectionResponse: '',
      rejectedDmoRequestId: '',
      handleDmoButtonText: 'Send',
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await Promise.all([
        this.$store.dispatch('changeRequests/getDMOPartnerRequests'),
        this.$store.dispatch('changeRequests/getPendingEvents'),
        this.$store.dispatch('changeRequests/getPendingCities'),
        this.$store.dispatch('changeRequests/getMembershipRequests'),
        this.$store.dispatch('changeRequests/getPendingLocations'),
        this.$store.dispatch('changeRequests/getUnverifiedUsers'),
      ]);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  components: {
    BreadcrumbsHelper,
    Loading,
  },
  methods: {
    openDmoModal(requestId) {
      this.dmoRejectionResponse = '';
      this.rejectedDmoRequestId = requestId;
      this.showRejectDmoModal = true;
    },
    closeDmoModal() {
      this.dmoRejectionResponse = '';
      this.rejectedDmoRequestId = '';
      this.showRejectDmoModal = false;
    },
    async dmoSendAcceptRejectRequest(accept, requestId) {
      if (!accept && !this.dmoRejectionResponse.length) {
        return;
      }

      try {
        this.isLoading = true;
        this.handleDmoButtonText = 'Sending...';

        const response = await axios.post(`${process.env.VUE_APP_API_ROOT}/roles/request/${requestId}`, {
          response: accept ? '' : this.dmoRejectionResponse,
          action: accept ? 'Approve' : 'Reject',
        });

        if (response.data.success) {
          this.$bvToast.toast(`You have successfully ${accept ? 'accepted' : 'rejected'} this request.`, {
            title: 'Success',
            autoHideDelay: 5000,
            appendToast: true,
          });

          this.showRejectDmoModal = false;
        } else {
          this.$bvToast.toast('Something went wrong. Please try again.', {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong.', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
        console.log(err);
      } finally {
        await this.$store.dispatch('changeRequests/getDMOPartnerRequests');
        this.isLoading = false;
        this.handleDmoButtonText = 'Send';
      }
    },
    async membershipSendAcceptRejectRequest(accept, requestId) {
      try {
        this.isLoading = true;

        const url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/requests/${requestId}/${accept}`;
        const response = await axios.patch(url);
        if (response.status === 200) {
          this.$bvToast.toast(`You have successfully ${accept ? 'accepted' : 'rejected'} this request.`, {
            title: 'Success',
            autoHideDelay: 5000,
            appendToast: true,
          });
          await this.$store.dispatch('changeRequests/getMembershipRequests');
        } else {
          this.$bvToast.toast(JSON.parse(response.data).message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async rejectChangeRequest(requestId, type) {
      try {
        this.isLoading = true;

        const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/admin/rejectChangeRequest/${requestId}`);
        if (response.data.success) {
          this.$bvToast.toast(`${response.data.message}`, {
            title: 'Success',
            autoHideDelay: 5000,
            appendToast: true,
          });
          if (type === 'event') {
            await this.$store.dispatch('changeRequests/getPendingEvents');
          } else if (type === 'location') {
            await this.$store.dispatch('changeRequests/getPendingLocations');
          } else {
            await this.$store.dispatch('changeRequests/getPendingCities');
          }
        } else {
          this.$bvToast.toast(`${response.data.message}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async approveChangeRequest(requestId, type) {
      try {
        this.isLoading = true;

        const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/admin/approveChangeRequest/${requestId}`);
        if (response.data.success) {
          if (type === 'event') {
            await this.$store.dispatch('changeRequests/getPendingEvents');
          } else {
            await this.$store.dispatch('changeRequests/getPendingLocations');
          }
        } else {
          this.$bvToast.toast(`${response.data.message}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async approveCityChangeRequest(requestId) {
      try {
        this.isLoading = true;

        const response = await axios.post(`${process.env.VUE_APP_API_ROOT}/cities/approveChangeRequest?id=${requestId}`);

        if (response.data.success) {
          await this.$store.dispatch('changeRequests/getPendingCities');
          this.$bvToast.toast('Change Request Approved', {
            title: 'Success',
            autoHideDelay: 5000,
            appendToast: true,
          });
        } else {
          // eslint-disable-next-line no-console
          console.log(response.data.message);
          this.$bvToast.toast(`${response.data.message}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async rejectCityChangeRequest(requestId) {
      try {
        this.isLoading = true;

        const response = await axios.post(`${process.env.VUE_APP_API_ROOT}/cities/rejectChangeRequest?id=${requestId}`);

        if (response.data.success) {
          await this.$store.dispatch('changeRequests/getPendingCities');
          this.$bvToast.toast('Change Request Rejected', {
            title: 'Success',
            autoHideDelay: 5000,
            appendToast: true,
          });
        } else {
          // eslint-disable-next-line no-console
          console.log(response.data.message);
          this.$bvToast.toast(`${response.data.message}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async approveEventChange(requestId, eventId) {
      try {
        this.isLoading = true;
        const requestInfo = {
          change_request_id: requestId,
          event_id: eventId,
        };

        await axios.post(`${process.env.VUE_APP_API_EVENTS_ROOT}/events/approveEventChangeRequest`, JSON.stringify(requestInfo)).then(
          async (response) => {
            await this.approveChangeRequest(requestId, 'event');
            this.$bvToast.toast(`${response.data.message}`, {
              title: 'Success',
              autoHideDelay: 5000,
              appendToast: true,
            });
          },
          (error) => {
            // eslint-disable-next-line no-console
            console.log(error);
            this.$bvToast.toast(`${error.response.data}`, {
              title: 'Error',
              autoHideDelay: 5000,
              appendToast: true,
            });
          }
        );
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async approveLocationChange(requestId, locationId) {
      try {
        this.isLoading = true;

        const requestInfo = {
          change_request_id: requestId,
          location_id: locationId,
        };
        await axios.post(`${process.env.VUE_APP_API_LOCATIONS_ROOT}/locations/approveLocationChangeRequest`, JSON.stringify(requestInfo)).then(
          async (response) => {
            await this.approveChangeRequest(requestId, 'location');
            this.$bvToast.toast(`${response.data.message}`, {
              title: 'Success',
              autoHideDelay: 5000,
              appendToast: true,
            });
          },
          (error) => {
            // eslint-disable-next-line no-console
            console.log(error);
            this.$bvToast.toast(`${error.response.data}`, {
              title: 'Error',
              autoHideDelay: 5000,
              appendToast: true,
            });
          }
        );
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async verifyUser(username) {
      try {
        this.isLoading = true;
        const response = await axios.post(`${process.env.VUE_APP_API_USERS_ROOT}/users/verifyEmail`, { username });
        if (response.status === 200) {
          await this.$store.dispatch('changeRequests/getUnverifiedUsers');
        } else {
          this.$bvToast.toast(`${response.statusText}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async adminDeleteUnverifiedUser(username, email) {
      this.isLoading = true;
      const url = `${process.env.VUE_APP_API_USERS_ROOT}/users/adminDeleteUnverifiedUser/${username}/${email}`;
      const response = await axios.delete(url);
      if (response.status === 200) {
        this.$bvToast.toast('You have successfully removed this unverified user', {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
        });
        this.$store.dispatch('changeRequests/getUnverifiedUsers');
      } else {
        this.$bvToast.toast(JSON.parse(response.data).message, {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }

      this.isLoading = false;
    },
    formatOrganizationsField(organizationsList) {
      const orgs = organizationsList.map((x) => x.name).join(', ');

      if (orgs.length > 40) {
        return `${orgs.slice(0, 37)}...`;
      }

      return orgs;
    },
  },
})

// ToDo : refactor Breadcrumbs method to not require this
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["Breadcrumbs"] }] */
class Admin extends Vue {
  get Breadcrumbs() {
    return [
      {
        text: 'Dashboard',
        href: '/admin',
      },
      {
        text: 'Admin',
        href: '/admin',
        active: true,
      },
    ];
  }
}

export default Admin;
</script>

<style lang="scss" scoped>
.dmo-table-row-top {
  &>* {
    padding-bottom: 0;
  }
}

.dmo-table-row-bottom {
  height: 2rem;

  &>* {
    padding-top: 0;
  }
}

.table-dmo tbody tr:nth-of-type(4n + 1),
.table-dmo tbody tr:nth-of-type(4n + 2) {
  background-color: rgba(248, 248, 248, 1);
}

.card-body h1 {
  margin: 0px 0 10px 0;
}

.card {
  border: none;
}

.remove-btn {
  background-color: white !important;
  border: 1px solid #4e97b2;
  border-radius: var(--rounded);;
  color: #4e97b2 !important;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0.2rem 0.5rem;

  &:hover {
    background-color: red !important;
    color: white !important;
  }
}

textarea {
  border-color: #919191;
  resize: none;
  height: 10rem;
  padding: 12px;
}

.modal {
  display: block;
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  text-align: left;
  background-color: #fefefe;
  margin: 15% auto;
  padding: 32px;
  border: 1px solid #888;
  border-radius: var(--rounded-lg);
  width: 80%;
}

.modal-actions {
  margin-top: 2rem;
  display: flex;
  gap: 12px;
}

.modal-error {
  margin-bottom: 0;
  color: black;
}
</style>
